/* eslint-disable max-len */
import React, { Component } from 'react';
import Button from 'antd/es/button/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Card from 'antd/es/card';
import Flex from 'antd/es/flex';
import Divider from 'antd/es/divider';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';
import Text from 'antd/es/typography/Text';
import { observer } from 'mobx-react';
import { RoutesConfig } from '../../../config';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { IForgotPasswordForm } from '../store';

const routesConfig = new RoutesConfig();

class ForgotPassword extends Component<IRootStoreProps> {
  componentWillUnmount(): void {
    this.props.store.dispose();
  }

  render() {
    const { store } = this.props;
    return (
      <Card title="Восстановление пароля" style={{ width: '100%' }}>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          onFinish={store.auth.forgotPassword}
          layout="vertical"
          autoComplete="off"
        >
          {store.requestSuccess ? (
            <Flex justify="center" align="center" vertical>
              <Text style={{ marginBottom: 30 }}>
                {
                  'Письмо для восстановления пароля отправлено Вам на Email. Перейдите по ссылке, чтобы создать новый пароль.'
                }
              </Text>

              <Link to={routesConfig.home}>
                <Button color="default" variant="outlined">
                  На главную
                </Button>
              </Link>
              <Divider />
            </Flex>
          ) : (
            <>
              <Form.Item<IForgotPasswordForm>
                name="email"
                label="Email"
                rules={[
                  { type: 'email', message: 'Этот Email не валидный!' },
                  { required: true, message: 'Пожалуйста введите Email!' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={store.loading}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  {'Восстановить'}
                </Button>
              </Form.Item>
            </>
          )}
          {store.requestError && <Alert message="Error" description={store.requestError} type="error" showIcon />}
        </Form>
        <Flex justify="center" align="center">
          <Link to={routesConfig.login}>
            <Button type="text">Войти</Button>
          </Link>
          <Divider type={'vertical'} />
          <Link to={routesConfig.registration}>
            <Button type="text">Зарегистрироваться</Button>
          </Link>
        </Flex>
      </Card>
    );
  }
}

export const ForgotPasswordPage: WithoutStore = withStore(observer(ForgotPassword));
